import { useQuery } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axiosInstance'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'
import { GenerationStatus, KeywordCategory } from '../types'

type ReturnType = {
  data:
    | {
        data: KeywordCategory[] | null
        theme_generation_status: GenerationStatus
      }
    | undefined
  isLoading: boolean
  isFetching: boolean
  refetch: () => void
  error: unknown
}

const fetchCategories = async ({
  companyId,
  domainId,
}: {
  companyId: string
  domainId?: string | null
}): Promise<{
  data: KeywordCategory[] | null
  theme_generation_status: GenerationStatus
}> => {
  const url = `${SEO_SERVICE_BASE_URL}/companies/${companyId}/keyword-discovery/domains/${domainId}/categories`
  const response = await axios.get(url)
  return response.data
}

export const useKeywordCategories = ({
  companyId,
  domainId,
  enabled,
}: {
  companyId: string
  domainId?: string | null
  enabled: boolean
}): ReturnType => {
  const { isLoading, isFetching, error, refetch, data } = useQuery({
    queryKey: ['keyword-categories', companyId, domainId],
    queryFn: () =>
      fetchCategories({
        companyId,
        domainId,
      }),
    enabled,
    refetchOnWindowFocus: false,
    retry: 2,
  })

  return {
    data,
    isLoading,
    isFetching,
    refetch,
    error,
  }
}
